// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Nipe","addWidgetButton":"Header_addWidgetButton__1wDsZ","dashboardTabs":"Header_dashboardTabs__1LxYo","active":"Header_active__1THDI"};